const state = {
	sessionsLog: []
}

export default state
